import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Search from "@material-ui/icons/Search"
import Close from "@material-ui/icons/Close"
import React, { ReactElement } from "react"
import AdPlaceSelect from "Components/Table/AdPlaceSelect"
import StatusSelect from "./StatusSelect"
import TimePicker from "Components/TimePicker"
import { useInputChange } from "Hooks/basic"

const useStyles = makeStyles({
    toolWrap: {
        padding: 15,
        marginBottom: 30,
        display: "flex",
        justifyContent: "space-around",
    },
    textSearch: {
        width: 400,
    },
    selectWrap: {
        display: "inline-block",
        marginLeft: 20,
    },
})

interface ComponentProps {
    keyword: string,
    channelName?: string,
    onSearch: (query: {
        keyword?: string | null,
        status?: string,
        placeId?: number,
        startTime?: Date,
        endTime?: Date,
        isDraft?: boolean,
    }) => void,
}

const EnhancerToolBar = (props: ComponentProps): ReactElement | null => {
    const classes = useStyles()
    const { keyword, onSearch, channelName } = props
    const placeholder = channelName === "species" ? "请输入预约说明、标题、作者或预约人的关键字" : "请输入内容、标题、作者或负责人的关键字"
    const { handleChange, text, clearText } = useInputChange("")
    const handleSearch = () => {
        onSearch({ keyword: text })
    }
    const handleClear = () => {
        clearText()
        onSearch({ keyword: null })
    }
    return (
        <div className={classes.toolWrap}>
            <TextField
                className={classes.textSearch}
                placeholder={placeholder}
                onChange={handleChange}
                onKeyUp={(event) => {
                    if (event.keyCode === 13) {
                        handleSearch()
                    }
                }}
                value={text}
                InputProps={{
                    endAdornment: keyword ? (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClear}>
                                <Close />
                            </IconButton>
                        </InputAdornment>
                    ) : (
                        <InputAdornment position="end">
                            <IconButton onClick={handleSearch}>
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <div className={classes.selectWrap}>
                <AdPlaceSelect channelName={channelName} onSearch={(id) => {
                    onSearch({
                        placeId: id,
                    })
                }}/>
            </div>
            <div className={classes.selectWrap}>
                <StatusSelect onSelectStatus={(status: string) => {
                    onSearch({
                        status,
                    })
                }}/>
            </div>
            <div className={classes.selectWrap}>
                <TimePicker onSelectDateRange={( (dateRange: Date[]) => {
                    const [ startTime, endTime ] = dateRange
                    onSearch({
                        startTime, endTime,
                    })
                })}/>
            </div>
        </div>
    )
}

export default EnhancerToolBar
